// extracted by mini-css-extract-plugin
export default {"container":"Card_container__pKdCH","establishmentName":"Card_establishmentName__0RVyg","buttonArea":"Card_buttonArea__v7sZZ","thumbnailsArea":"Card_thumbnailsArea__j09wj"};